<template>
	<div id="tickets" class="tab-content">
		<clip-loader class="dashboard-tab-loader" :loading="isCargandoEvento" :color="'var(--color-blue-link)'" :size="'52px'"></clip-loader>
		<div class="tickets-main" v-if="!isCargandoEvento">
			<div class="filtros">
				<div class="filtro-group">
					<label for="fTransaccion">Transacción Id</label>
					<input type="text" v-model="filtros.transaccion" @keypress="soloNumeros" name="fTransaccion" id="fTransaccion" v-on:keyup.enter="getTickets()" />
				</div>
				<div class="filtro-group">
					<label for="fId">Ticket Id</label>
					<input type="text" v-model="filtros.id" @keypress="soloNumeros" name="fId" id="fId" v-on:keyup.enter="getTickets()" />
				</div>
				<div class="filtro-group">
					<label for="fEstado">Estado</label>
					<select name="fEstado" id="fEstado" v-model="filtros.estado">
						<option value="">(Todos)</option>
						<option value="E">Emitido</option>
						<option value="U">Utilizado</option>
						<option value="C">Cancelado</option>
						<option value="P">Pagando</option>
						<option value="A">Anulado</option>
					</select>
				</div>
				<div class="filtro-group">
					<label for="fMedio">Medio</label>
					<select name="fMedio" id="fMedio" v-model="filtros.medio">
						<option value="">(Todos)</option>
						<option value="W">Web</option>
						<option value="A">App</option>
						<option value="T">Totem</option>
						<option value="R">RedPagos</option>
					</select>
				</div>
				<div class="filtro-group">
					<label for="fTipo">Tipo</label>
					<select name="fTipo" id="fTipo" v-model="filtros.tipo">
						<option value="">(Todos)</option>
						<option value="C">Canje</option>
						<option value="V">Venta</option>
						<option value="I">Invitación</option>
					</select>
				</div>
				<div class="filtro-group">
					<label for="fEspectador">Espectador</label>
					<input type="text" v-model="filtros.espectador" name="fEspectador" id="fEspectador" v-on:keyup.enter="getTickets()" />
				</div>
				<div class="filtro-group">
					<label for="fDocumento">Documento</label>
					<input type="text" v-model="filtros.documento" name="fDocumento" id="fDocumento" v-on:keyup.enter="getTickets()" />
				</div>
				<div class="filtro-group">
					<label for="fTribuna">Tribuna</label>
					<select name="fTribuna" id="fTribuna" v-model="filtros.tribuna" @change="tribunaChanged()">
						<option value="0">(Todas)</option>
						<option :value="tribuna.TribunaId" v-for="tribuna in filtros.ColTribunas" :key="tribuna.TribunaId">{{ tribuna.TribunaNombre }}</option>
					</select>
				</div>
				<div class="filtro-group">
					<label for="fSector">Sector</label>
					<select name="fSector" id="fSector" v-model="filtros.sector" @change="sectorChanged()">
						<option value="">(Todos)</option>
						<option :value="sector.SectorCod" v-for="sector in filtros.ColSectores" :key="sector.SectorCod">{{ sector.SectorDescripcion }}</option>
					</select>
				</div>
				<div class="filtro-group">
					<label for="fFila">Fila</label>
					<select name="fFila" id="fFila" v-model="filtros.fila" @change="filaChanged()">
						<option value="0">(Todas)</option>
						<option :value="fila.FilaId" v-for="fila in filtros.ColFilas" :key="fila.FilaId">{{ fila.FilaNombre }}</option>
					</select>
				</div>
				<div class="filtro-group">
					<label for="fAsiento">Asiento</label>
					<select name="fAsiento" id="fAsiento" v-model="filtros.asiento">
						<option value="0">(Todos)</option>
						<option :value="asiento.AsientoId" v-for="asiento in filtros.ColAsientos" :key="asiento.AsientoId">{{ asiento.AsientoNombre }}</option>
					</select>
				</div>
				<button :disabled="isCargandoEvento" @click.prevent="getTickets()">Buscar</button>
				<button class="limpiar-filtros" @click.prevent="limpiarFiltros()" v-if="showLimpiarFiltros"><i class='bx bx-x'></i>Limpiar filtros</button>
			</div>
			<div class="tb">
				<div class="tb-header">
					<div style="width: 8%;" class="tb-header-th">Transacción</div>
					<div style="width: 8%;" class="tb-header-th">Medio</div>
					<div style="width: 8%;" class="tb-header-th">Ticket Id</div>
					<div style="width: 10%;" class="tb-header-th">Emitido el</div>
					<div style="width: 19%;" class="tb-header-th">Espectador</div>
					<div style="width: 10%;" class="tb-header-th">Documento</div>
					<div style="width: 12%;" class="tb-header-th">Tribuna</div>
					<div style="width: 12%;" class="tb-header-th">Sector</div>
					<div style="width: 5%;" class="tb-header-th">Importe</div>
					<div style="width: 8%; justify-content: center;" class="tb-header-th">Estado</div>
				</div>
				<div class="tb-body" v-if="!isCargandoEvento && Tickets.length > 0">
					<div class="tb-body-row tb-body-row-ticket" v-for="ticket in Tickets" :key="ticket.TicketId" @click.prevent="verTicket(ticket.TicketId)">
						<div style="width: 8%;" class="tb-body-td tb-body-td-transaccion">
							<div>...{{ ticket.TransaccionId.substring(ticket.TransaccionId.length - 4) }}</div>
							<div class="copiar-transaccion" @click.stop="copiar(ticket.TransaccionId)">
								<i class='bx bx-copy'></i>
							</div>
						</div>
						<div style="width: 8%;" class="tb-body-td">{{ ticket.TransaccionMedioTxt }}</div>
						<div style="width: 8%;" class="tb-body-td">{{ ticket.TicketId }}</div>
						<div style="width: 10%;" class="tb-body-td">{{ ticket.TicketFechaEmisionTxt }}</div>
						<div style="width: 19%; font-weight: 600;" class="tb-body-td">{{ ticket.PersonaNombreCompleto }}</div>
						<div style="width: 10%;" class="tb-body-td">{{ ticket.PersonaDocumento }}</div>
						<div style="width: 12%;" class="tb-body-td">{{ ticket.TribunaNombre }}</div>
						<div style="width: 12%;" class="tb-body-td">{{ ticket.SectorDescripcion }}</div>
						<div style="width: 5%;" class="tb-body-td">{{ ticket.TicketImporte }}</div>
						<div style="width: 8%; text-align: center;" class="tb-body-td tb-body-td-estado"><span :class="ticket.TicketEstado === 'P' ? 'pagando' : (ticket.TicketEstado === 'A' || ticket.TicketEstado === 'C') ? 'cancelado' : ''">{{ ticket.TicketEstadoTxt }}</span></div>
					</div>
				</div>
				<div class="tb-body" v-else>
					<clip-loader class="dashboard-tab-loader" :loading="isCargandoEvento" v-if="isCargandoEvento" :color="'var(--color-blue-link)'" :size="'52px'"></clip-loader>
					<div class="no-results" v-else>
						No se encontraron tickets con esos filtros
					</div>
				</div>
			</div>
			<Pagination
				:page="Pagina"
				:maxPaginas="CantPaginas"
				:loading="isCargandoEvento"
				@prevPage="prevPage()"
				@nextPage="nextPage()"
				@firstPage="firstPage()"
				@lastPage="lastPage()"
			></Pagination>
		</div>
		<modal name="promptVerTicket" class="promptVerTicket" transition="scale" :clickToClose="true" @closed="promptVerTicketClosed()">
			<div class="ver-ticket-close" @click="$modal.hide('promptVerTicket')">
				<i class='bx bx-x'></i>
			</div>
			<div class="ver-ticket-content" v-if="!isCargandoTicket && Ticket">
				<div class="ticket-header">
					<span class="title">Ticket #{{ Ticket.TicketId }}</span>
				</div>
				<div class="ticket-main">
					<span class="group-title">Datos del ticket</span>
					<div class="ticket-row">
						<div class="ticket-group">
							<span class="label">Id</span>
							<span class="value">{{ Ticket.TicketId }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Transacción</span>
							<span class="value">{{ Ticket.TransaccionId }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Código único</span>
							<span class="value">{{ Ticket.TicketCodigo.slice(0, 12)}}... <i class='bx bx-copy' content="Copiar código" v-tippy="{ placement : 'left', arrow: true}" @click="copiar(Ticket.TicketCodigo)"></i></span>
						</div>
						<div class="ticket-group">
							<span class="label">Estado</span>
							<span class="value">{{ Ticket.TicketEstadoTxt }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Emitido el</span>
							<span class="value">{{ Ticket.TicketFechaEmisionTxt }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Utilizado el</span>
							<span class="value">{{ Ticket.TicketFechaUtilizacionTxt }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Tipo</span>
							<span class="value">{{ Ticket.TicketTipoTxt }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Importe</span>
							<span class="value">{{ Ticket.TicketImporte }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Medio</span>
							<span class="value">{{ Ticket.TransaccionMedioTxt }}</span>
						</div>
					</div>
					<span class="group-title">Datos del espectador</span>
					<div class="ticket-row ticket-row-2">
						<div class="ticket-group">
							<span class="label">Nombre</span>
							<span class="value">{{ Ticket.PersonaNombre }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Apellido</span>
							<span class="value">{{ Ticket.PersonaApellido }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Tipo de documento</span>
							<span class="value">{{ Ticket.PersonaDocumentoTipoNombre }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Documento</span>
							<span class="value">{{ Ticket.PersonaDocumento }}</span>
						</div>
					</div>
					<span class="group-title">Usuario emisor</span>
					<div class="ticket-row ticket-row-1">
						<div class="ticket-group">
							<span class="value">{{ Ticket.UsuarioEmail }}</span>
						</div>
					</div>
					<span class="group-title">Ubicación</span>
					<div class="ticket-row ticket-row-4">
						<div class="ticket-group">
							<span class="label">Tribuna</span>
							<span class="value">{{ Ticket.TribunaNombre }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Sector</span>
							<span class="value">{{ Ticket.SectorDescripcion }}</span>
						</div>
						<div class="ticket-group">
							<span class="label">Fila</span>
							<span class="value" v-if="Ticket.FilaId > 0">{{ Ticket.FilaId }}</span>
							<span class="value" v-else>-</span>
						</div>
						<div class="ticket-group">
							<span class="label">Asiento</span>
							<span class="value" v-if="Ticket.AsientoId > 0">{{ Ticket.AsientoId }}</span>
							<span class="value" v-else>-</span>
						</div>
					</div>
					<span class="group-title" v-if="Ticket.TicketEstado === 'E' || Ticket.TicketEstado === 'U' || Ticket.TicketEstado === 'A'">Link al pdf</span>
					<div class="ticket-row ticket-row-1" v-if="Ticket.TicketEstado === 'E' || Ticket.TicketEstado === 'U' || Ticket.TicketEstado === 'A'">
						<div class="ticket-group">
							<span class="value"><a :href="Ticket.TicketURLS3" target="_blank">{{ Ticket.TicketURLS3 }}</a><i class='bx bx-copy' style="color: var(--color-blue-link)" content="Copiar link" v-tippy="{ placement : 'left', arrow: true}" @click="copiar(Ticket.TicketURLS3)"></i></span>
						</div>
					</div>
					<div class="ticket-row ticket-row-2" v-if="Ticket.TicketEstado === 'E'">
						<button class="cancelar-ticket" @click.prevent="cancelarTicket(Ticket.TicketId)" v-if="orAc.Permisos.includes('CancelarTicket')">Cancelar ticket</button>
						<button @click.prevent="enviarPorCorreo(Ticket.TicketId)" v-if="orAc.Permisos.includes('EnviarTicketPorCorreo')"><i class='bx bxs-envelope' ></i>Enviar por correo</button>
					</div>
				</div>
			</div>
			<div class="ver-ticket-content" v-else>
				<clip-loader :loading="isCargandoTicket" v-if="isCargandoTicket" :color="'var(--color-blue-link)'" :size="'52px'" style="margin: 80px auto;"></clip-loader>
			</div>
		</modal>
		<modal name="promptEnviarPorCorreo" class="promptEnviarPorCorreo" transition="scale" :clickToClose="true" @closed="promptEnviarPorCorreoClosed()">
			<div class="ver-ticket-close" @click="$modal.hide('promptEnviarPorCorreo')">
				<i class='bx bx-x'></i>
			</div>
			<div class="ver-ticket-content" v-if="!isCargandoEnviarPorCorreo && ticketsTransaccion.length > 0">
				<div class="ticket-header">
					<span class="title">Enviar tickets por correo electrónico</span>
				</div>
				<div class="ticket-main">
					<span class="group-title">Tickets de la transacción</span>
					<div class="ticket-row ticket-row-1">
						<div class="tb">
							<div class="tb-header">
								<div style="width: 15%;" class="tb-header-th">Ticket</div>
								<div style="width: 20%;" class="tb-header-th">Tipo</div>
								<div style="width: 25%;" class="tb-header-th">Emitido el</div>
								<div style="width: 40%;" class="tb-header-th">Espectador</div>
							</div>
							<div class="tb-body" v-if="ticketsTransaccion.length > 0">
								<div class="tb-body-row tb-body-row-ticket" v-for="ticket in ticketsTransaccion" :key="ticket.TicketId">
									<div style="width: 15%;" class="tb-body-td">{{ ticket.TicketId }}</div>
									<div style="width: 20%;" class="tb-body-td">{{ ticket.TicketTipoTxt }}</div>
									<div style="width: 25%;" class="tb-body-td">{{ ticket.TicketFechaEmisionTxt }}</div>
									<div style="width: 40%;" class="tb-body-td">{{ ticket.PersonaNombreCompleto }}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="ticket-row ticket-row-2">
						<div class="ticket-group">
							<span class="label">Correo electrónico</span>
							<input type="email" v-model="usuarioEmailTransaccion">
						</div>
						<button @click.prevent="enviarPorCorreoConfirmar(enviarPorCorreoTicketId)"><i class='bx bxs-envelope' ></i>Enviar por correo</button>
					</div>
				</div>
			</div>
			<div class="ver-ticket-content" v-else>
				<clip-loader :loading="isCargandoEnviarPorCorreo" v-if="isCargandoEnviarPorCorreo" :color="'var(--color-blue-link)'" :size="'52px'" style="margin: 80px auto;"></clip-loader>
			</div>
		</modal>
	</div>
</template>

<script>
	import axios from 'axios'
	import { mapState, mapActions, mapGetters }  from 'vuex';
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
	import Pagination from "../../components/Pagination.vue";

	export default {
		data(){
			return{
				isCargandoEvento: true,
				Tickets: [],
				EventoId: Number(this.$route.params.eventoId),

				// Paginación
				Pagina: 1,
				CantPaginas: 1,
				reinicioPaginacion: false,

				filtros: {
					transaccion: '',
					id: '',
					estado: '',
					espectador: '',
					tribuna: 0,
					sector: '',
					medio: '',
					tipo: '',
					documento: '',
					fila: 0,
					asiento: 0,

					ColTribunas: [],
					ColSectores: [],
					ColFilas: [],
					ColAsientos: []
				},

				Ticket: null,
				isCargandoTicket: false,

				ticketsTransaccion: [],
				isCargandoEnviarPorCorreo: false,
				usuarioEmailTransaccion: '',
				enviarPorCorreoTicketId: null
			}
		},
		components: {
			ClipLoader,
			Pagination
		},
		computed: {
			...mapState('AuthModule', ['user', 'organizadorActivo']),
			...mapGetters('AuthModule', ['orAc']),

			showLimpiarFiltros(){
				if(
					this.filtros.transaccion === '' &&
					this.filtros.id === '' &&
					this.filtros.estado === '' &&
					this.filtros.espectador === '' &&
					this.filtros.tribuna === 0 &&
					this.filtros.sector === '' &&
					this.filtros.medio === '' &&
					this.filtros.tipo === '' &&
					this.filtros.documento === '' &&
					this.filtros.fila === 0 &&
					this.filtros.asiento === 0
				){
					return false
				} else {
					return true
				}
			}
		},
		async mounted(){
			this.getTribunas();
			await this.getTickets();
		},
		methods: {
			...mapActions('AuthModule', ['logout']),

			soloNumeros ($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if (keyCode < 48 || keyCode > 57) {
					$event.preventDefault();
				}
			},
			async copiar(texto) {
				await this.$copyText(texto).then(
					function () {
					},
					function () {}
				);

				this.$store.dispatch('showSuccess', 'Copiado!')
			},
			async getTribunas(){
				try {
					this.filtros.ColTribunas = [];

					let response = await axios.post('/WSOrgEveTribunas', {
						EventoId: Number(this.EventoId)
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							this.filtros.ColTribunas = response.data.SDTDashboardTribunas
						}
					}
				} catch (error) {
					console.log('Ocurrió un error al obtener las tribunas');
				}
			},
			async getSectores(){
				try {
					this.filtros.ColSectores = [];

					let response = await axios.post('/WSOrgEveSectores', {
						EventoId: Number(this.EventoId),
						TribunaId: Number(this.filtros.tribuna)
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							this.filtros.ColSectores = response.data.SDTDashboardSectores
						}
					}
				} catch (error) {
					console.log('Ocurrió un error al obtener los sectores');
				}
			},
			async getFilas(){
				try {
					this.filtros.ColFilas = [];

					let response = await axios.post('/WSOrgEveFilas', {
						EventoId: Number(this.EventoId),
						TribunaId: Number(this.filtros.tribuna),
						SectorCod: this.filtros.sector
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							this.filtros.ColFilas = response.data.SDTDashboardFilas
						}
					}
				} catch (error) {
					console.log('Ocurrió un error al obtener las filas');
				}
			},
			async getAsientos(){
				try {
					this.filtros.ColAsientos = [];

					let response = await axios.post('/WSOrgEveAsientos', {
						EventoId: Number(this.EventoId),
						TribunaId: Number(this.filtros.tribuna),
						SectorCod: this.filtros.sector,
						FilaId: Number(this.filtros.fila)
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							this.filtros.ColAsientos = response.data.SDTDashboardAsientos
						}
					}
				} catch (error) {
					console.log('Ocurrió un error al obtener los asientos');
				}
			},
			async getTickets(){
				try {
					this.Tickets = [];
					this.isCargandoEvento = true;

					let filtroTransaccion = this.filtros.transaccion
					if(!filtroTransaccion){
						filtroTransaccion = '80ed076b-89de-1899-1899-536d79b70d2a'
					}

					let response = await axios.post('/WSOrgEveTickets', {
						OrganizadorId: Number(this.organizadorActivo),
						UsuarioId: this.user.UsuarioId,
						EventoId: Number(this.EventoId),
						Pag: Number(this.Pagina),
						Limit: 50,
						FTicketId: this.filtros.id,
						FTransaccionId: filtroTransaccion,
						FTicketEstado: this.filtros.estado,
						FTransaccionMedio: this.filtros.medio,
						FTicketTipo: this.filtros.tipo,
						FPersonaNombreCompleto: this.filtros.espectador,
						FPersonaDocumento: this.filtros.documento,
						FTribunaId: Number(this.filtros.tribuna),
						FSectorCod: this.filtros.sector,
						FFilaId: Number(this.filtros.fila),
						FAsientoId: Number(this.filtros.asiento)
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 1){
						this.logout();
					} else {
						if(response.data.ErrorCod === 0){
							this.CantPaginas = response.data.CantPaginas
							this.Tickets = response.data.SDTDashboardEventoTickets
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error, intente nuevamente.')
					this.$router.push({ name: 'error' })
				} finally {
					this.isCargandoEvento = false
				}
			},
			async tribunaChanged(){
				this.filtros.ColSectores = [];
				this.filtros.ColFilas = [];
				this.filtros.ColAsientos = [];

				if(this.filtros.tribuna !== '0'){
					await this.getSectores();
				}
			},
			async sectorChanged(){
				this.filtros.ColFilas = [];
				this.filtros.ColAsientos = [];

				if(this.filtros.sector !== ''){
					await this.getFilas();
				}
			},
			async filaChanged(){
				this.filtros.ColAsientos = [];

				if(this.filtros.fila !== '0'){
					await this.getAsientos();
				}
			},
			async verTicket(id){
				try {
					this.isCargandoTicket = true
					this.$modal.show('promptVerTicket');
					let response = await axios.post('/WSOrgEveTicket', {
						OrganizadorId: Number(this.organizadorActivo),
						UsuarioId: this.user.UsuarioId,
						TicketId: Number(id)
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 0){
						this.Ticket = response.data.SDTDashboardEventoTicketInfo
					} else {
						this.$modal.hide('promptVerTicket');
						this.$store.dispatch('showError', 'Ocurrió un error al visualizar el ticket')
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error al visualizar el ticket')
				} finally {
					this.isCargandoTicket = false
				}
			},
			async promptVerTicketClosed(){
				this.Ticket = null;
			},
			async promptEnviarPorCorreoClosed(){
				this.ticketsTransaccion = []
				this.usuarioEmailTransaccion = ''
				this.enviarPorCorreoTicketId = null
			},
			async cancelarTicket(id){
				try {
					this.isCargandoTicket = true;
					let response = await axios.post('/WSOrgEveTicketCancelar', {
						OrganizadorId: Number(this.organizadorActivo),
						UsuarioId: this.user.UsuarioId,
						TicketId: Number(id)
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 0){
						this.$modal.hide('promptVerTicket');
						this.$store.dispatch('showSuccess', 'Ticket cancelado con éxito')
						await this.getTickets();
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error al cancelar el ticket')
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error al cancelar el ticket')
				} finally {
					this.isCargandoTicket = false
				}
			},
			async limpiarFiltros(){
				this.filtros.transaccion = ''
				this.filtros.id = ''
				this.filtros.estado = ''
				this.filtros.espectador = ''
				this.filtros.tribuna = 0
				this.filtros.sector = ''
				this.filtros.medio = ''
				this.filtros.tipo = ''
				this.filtros.documento = ''
				this.filtros.fila = 0
				this.filtros.asiento = 0

				await this.getTickets();
			},
			async enviarPorCorreo(id){
				try {
					this.isCargandoEnviarPorCorreo = true
					this.ticketsTransaccion = []
					this.enviarPorCorreoTicketId = Number(id)
					this.$modal.show('promptEnviarPorCorreo');

					let response = await axios.post('/WSOrgEveTransaccionTickets', {
						OrganizadorId: Number(this.organizadorActivo),
						UsuarioId: this.user.UsuarioId,
						TicketId: Number(id)
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 0){
						this.ticketsTransaccion = response.data.SDTDashboardEventoTickets
						this.usuarioEmailTransaccion = this.ticketsTransaccion[0].UsuarioEmail
					} else {
						this.$modal.hide('promptEnviarPorCorreo');
						this.$store.dispatch('showError', 'Ocurrió un error.')
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error.')
				} finally {
					this.isCargandoEnviarPorCorreo = false
				}
			},
			async enviarPorCorreoConfirmar(id){
				try {
					this.isCargandoEnviarPorCorreo = true

					let response = await axios.post('/WSOrgEveEnviarTickets', {
						OrganizadorId: Number(this.organizadorActivo),
						UsuarioId: this.user.UsuarioId,
						TicketId: Number(id),
						NewUsuarioEmail: this.usuarioEmailTransaccion.trim()
					}, { headers: {"Authorization" : `Bearer ${ this.user.AccessToken }`} });

					if(response.data.ErrorCod === 0){
						this.$store.dispatch('showSuccess', 'Tickets enviados correctamente')
						this.$modal.hide('promptEnviarPorCorreo');
					} else {
						if(response.data.ErrorCod === 1){
							this.logout()
						} else {
							if(response.data.ErrorCod === 20){
								this.$store.dispatch('showError', 'Ocurrió un error al intentar enviar los tickets.')
								this.$modal.hide('promptEnviarPorCorreo');
							} else {
								this.$store.dispatch('showError', response.data.ErrorDsc);
							}
						}
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error al intentar enviar los tickets.')
				} finally {
					this.isCargandoEnviarPorCorreo = false
				}
			},

			async prevPage() {
				if (this.Pagina > 1) {
					this.reinicioPaginacion = false;
					this.Pagina -= 1;
					this.getTickets();
				}
			},
			async nextPage() {
				if (this.Pagina < this.CantPaginas) {
					this.reinicioPaginacion = false;
					this.Pagina += 1;
					this.getTickets();
				}
			},
			async firstPage() {
				this.reinicioPaginacion = false;
				this.Pagina = 1;
				this.getTickets();
			},
			async lastPage() {
				this.reinicioPaginacion = false;
				this.Pagina = this.CantPaginas;
				this.getTickets();
			},
			async reiniciarPaginacion() {
				this.Pagina = 1;
				this.CantPaginas = 1;
			},
		}
	}
</script>

<style lang="scss" scoped>
	.tickets-main{
		width: 100%;
		@include flex(column, center, center);
		
		.filtros{
			width: 100%;
			display: grid;
			grid-template-columns: repeat(7, 1fr);
			grid-auto-rows: 1fr;
			grid-column-gap: 20px;
			grid-row-gap: 10px;
			margin: 0px;
			margin-bottom: 20px;
			align-items: end;

			.filtro-group{
				@include flex(column, center, flex-start);
				width: 100%;

				label{
					font-size: 11px;
					font-weight: var(--fw-500);
					line-height: 1em;
					margin-bottom: 4px;
				}

				input {
					-webkit-appearance: none;
					appearance: none;
					border: none;
					width: 100%;
					padding: 0px 14px;
					font-size: 12px;
					font-weight: var(--fw-400);
					line-height: 1.4em;
					width: 100%;
					border-radius: 8px;
					height: 38px;
					outline: none;
					box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;

					&::placeholder {
						color: #9aa5b5;
						opacity: 1;
					}

					&:-ms-input-placeholder {
						color: #9aa5b5;
					}

					&::-ms-input-placeholder {
						color: #9aa5b5;
					}

					&:focus-within {
						@include transition(all 0.2s);
						box-shadow: #222 0px 0px 0px 2px inset;

						&.form-input--error {
							box-shadow: var(--color-red-error) 0px 0px 0px 2px inset;
						}
					}

					&.form-input--error {
						box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
					}
				}

				select{
					@include sinApariencia();
					width: 100%;
					height: 38px;
					background-image: url('../../assets/ChevronUpDown.svg');
					background-repeat: no-repeat;
					background-size: 18px;
					background-position: right 5px center;
					background-color: transparent;
					font-size: 12px;
					font-weight: var(--fw-400);
					line-height: 1.4em;
					outline: none;
					border: none;
					box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
					padding: 0 14px;
					border-radius: 8px;
					cursor: pointer;

					&:focus{
						box-shadow: #222 0px 0px 0px 2px inset;
					}
				}
			}

			button{
				@include flex(row, center, center);
				background-color: var(--color-darker);
				border: 1px solid var(--color-darker);
				border-radius: 8px;
				outline: none;
				padding: 0px 14px;
				color: var(--color-white);
				font-size: 13px;
				font-weight: var(--fw-500);
				font-family: var(--font-sora);
				line-height: 1.4em;
				letter-spacing: 1px;
				margin: 0px;
				height: 38px;
				@include transition(all 0.2s);
				cursor: pointer;

				&:hover {
					background-color: var(--color-primary);
					border: 1px solid var(--color-darker);
					transform: translate(-0.25rem, -0.25rem);
					box-shadow: 0.25rem 0.25rem 0 var(--color-darker);
					color: var(--color-darker);
				}

				&:disabled {
					background-color: #e8e9eb;
					color: var(--color-darker);
					border-color: #e8e9eb;
					cursor: not-allowed;

					&:hover{
						box-shadow: none;
						transform: none;
						border-color: #e8e9eb;
					}
				}

				&.limpiar-filtros{
					background-color: #e8e9eb;
					color: var(--color-darker);
					border: none;
					font-size: 12px;

					i{
						font-size: 16px;
						margin-right: 5px;
					}

					&:hover{
						box-shadow: none;
						transform: none;
						border-color: #e8e9eb;
						opacity: 0.9;
					}
				}
			}
		}
	}

	.no-results{
		background-color: #e8e9eb;
		width: fit-content;
		margin: 40px auto 20px auto;
		@include flex(row, center, center);
		border-radius: 8px;
		padding: 5px 10px;
		text-align: center;
		font-weight: var(--fw-300);
		font-size: 13px;
	}
</style>